// import cloneDeep from 'lodash/cloneDeep';
import { mapWishlist } from '~/utils/wishlist';
import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator('wishlist');

const LOAD_WISHLISTS = constant('LOAD_WISHLISTS', true);
const ADD_WISHLIST = constant('ADD_WISHLIST', true);
const REMOVE_WISHLIST = constant('REMOVE_WISHLIST', true);

const SET_WISHLIST_BUTTON = constant('SET_WISHLIST_BUTTON');
const CLEAR_STATE = constant('CLEAR_STATE');

// const LOAD_COMBINED_DYNAMIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC_SUCCESS';
import { LOAD_COMBINED_DYNAMIC } from '~/redux/reducers/info';

const initialState = {
  wishlistObj: {
    wishlists: [],
    isWishlisted: {}
  },
  error: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CLEAR_STATE:
      return initialState;
    case LOAD_WISHLISTS.PENDING:
      return {
        ...state,
        loading: true,
      };
    case LOAD_WISHLISTS.RESOLVED:
      return {
        ...state,
        loading: false,
        wishlistObj: mapWishlist(action.data),
      };
    case LOAD_WISHLISTS.REJECTED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case LOAD_COMBINED_DYNAMIC.RESOLVED:
      return {
        ...state,
        loading: false,
        wishlistObj: mapWishlist(action.data.wishlist),
      };
    case SET_WISHLIST_BUTTON: // eslint-disable-line
      const wishlistObj = { ...state.wishlistObj };
      wishlistObj.isWishlisted[action.tripId] = {
        loading: true,
        state: action.state
      };
      return {
        ...state,
        wishlistObj
      };
    default:
      return state;
  }
}

export const actions = {
  clearState: () => ({
    type: CLEAR_STATE
  }),
  setWishlistButton: (tripId, state) => ({
    type: SET_WISHLIST_BUTTON,
    tripId,
    state
  }),
  loadWishlists: () => ({
    type: LOAD_WISHLISTS,
    promise: api.get('/users/me/wishlists'),
  }),
  addWishlist: (tripId) => {
    return {
      type: ADD_WISHLIST,
      promise: api.post(`/trips/${tripId}/wishlist`),
      tripId,
    };
  },
  removeWishlist: (tripId) => {
    return {
      type: REMOVE_WISHLIST,
      promise: api.delete(`/trips/${tripId}/wishlist`),
      tripId,
    };
  }
};

export const analytics = {
  [ADD_WISHLIST.PENDING]: action => ({ name: 'Add Wishlist', category: 'Trip', data: { trip_id: action.tripId } }),
  [REMOVE_WISHLIST.PENDING]: action => ({name: 'Remove Wishlist', category: 'Trip', data: { trip_id: action.tripId } }),
};
